<template>
  <div class="vcl-table-tooltip--root">
    <vp-tooltip class="vcl-table-tooltip" v-bind="tooltipProps">
      <template #header>
        <div class="vcl-table-tooltip__header" v-if="$slots.header || title || icon">
          <slot name="header">
            <VpIcon v-if="icon" class="vcl-table-tooltip__header-icon" v-bind="{ icon, style: tooltipProps.iconStyles }"/>
            <p v-if="title" class="vcl-table-tooltip__header-title">{{ title }}</p>
          </slot>
        </div>
      </template>
      <template #target>
        <slot name="target" />
      </template>
      <template #default>
        <div class="vcl-table-tooltip__content">
          <div v-if="!$slots.default" class="vcl-table-tooltip__empty-state-content">
            <h4 v-if="emptyStateMessage && emptyStateMessage.title" class="vcl-table-tooltip__empty-state-title">{{ emptyStateMessage.title }}</h4>
            <p v-if="emptyStateMessage && emptyStateMessage.description" class="vcl-table-tooltip__empty-state-description" v-html="emptyStateMessage.description"></p>
          </div>
          <slot />
        </div>
      </template>
    </vp-tooltip>
  </div>
</template>

<script>

export default {
  name: 'VpTableTooltip',
  props: {
    title: { 
      type: String, 
      default: '',
    },
    headerIcon: { 
      type: String, 
      default: '',
    },
    emptyStateMessage: { 
      type: Object, 
      default: () => ({
        title: 'No Details Found',
      }),
    },
    options: {
      type: Object,
      default: () => ({}),
    }
  },
  computed: {
    icon() {
      return this.headerIcon || this.options.icon;
    },
    tooltipProps() {
      return {
        offset: [20, 10],
        placement: 'bottom-end',
        fallbackPlacements:['top-end', 'left'],
        enableScrolling: true,
        ...(this.options || {}),
        styles: {
          minWidth: '187px',
          width: 'unset',
          maxWidth: '300px',
          maxHeight: '425px',
          borderRadius: '6px',
          arrow: { bottom: { color: '#F4F7F8' } },
          zIndex: 5,
          ...(this.options.styles || {}),
        },
        iconStyles: {
          color: '#016699',
          ...(this.options.iconStyles || {}),
        },
      };
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/colors.scss';

.vcl-table-tooltip {
  cursor: default;
  text-align: left;
  font-size: .75rem;
  &__header {
    gap: 0.5rem;
    display: flex;
    align-items: center;
    padding: .5rem 1rem;
    border-radius: 6px 6px 0 0;
    background-color: $backgroundgray;
    border-bottom: 1px solid $lightgray;
    p {
      margin: 0;
      color: $darkblue;
      font-size: 10px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  &__content {
    margin: 0;
    text-align: left;
    list-style: none;
    display: flex;
    row-gap: .5rem;
    padding: 0.75rem 1rem;
    flex-direction: column;
    & > * {
      line-height: 14px;
      padding-bottom: .5rem;
      border-bottom: 1px solid $lightgray;
      &:last-child {
        padding-bottom: 0;
        border-bottom: none;
      }
      & > * {
        font-size: 0.75rem;
      }
      a {
        color: $linkblue;
        text-decoration: underline;
      }
    }
  }
}
</style>
